(function () {
  const inWaveCustom = {
    removeTitleAttributes: (removeTitleAttributes = () => {
      // Select all anchor elements with class 'tmenu_item_link' inside a 'tmenu_item' which are inside a 'tmenu_nav'
      const links = document.querySelectorAll(".tmenu_item_link");
      // Iterate over each link and remove the title attribute
      if (links.length === 0) {
        setTimeout(() => {
          removeTitleAttributes();
        }, 50);
      } else {
        links.forEach((link) => {
          link.removeAttribute("title");
        });
      }
    }),
    run: function () {
      // Your functions go here
      this.removeTitleAttributes();
    },
  };

  // Run the custom object on document ready
  document.addEventListener("DOMContentLoaded", function () {
    inWaveCustom.run();
  });
})();
